export const formatAmount = (amount: number | undefined): string => {
  if (amount === undefined) {
    return '';
  }

  if (amount % 1 === 0) {
    return `£${amount.toString()}`;
  }

  return `£${amount.toFixed(2)}`;
};
